package nl.volleyplanner.web.controller.planner.rulesets_config_v2

import kotlinx.html.Entities
import kotlinx.html.FlowContent
import kotlinx.html.FlowOrPhrasingContent
import kotlinx.html.div
import kotlinx.html.strong
import nl.volleyplanner.api.planner.Ruleset
import nl.volleyplanner.web.base.SimpleComponent
import nl.volleyplanner.web.base.component.badge
import nl.volleyplanner.web.base.icon
import nl.volleyplanner.web.util.BootstrapColor

fun FlowContent.rulesetCardInfo(ruleset: Ruleset?) : Unit = div {
    div(classes = "d-flex flex-wrap small text-muted mb-1") {
        div(classes = "me-2") {
            icon("vp-icon-whistle")
            strong { +"${ruleset?.refereeRequiredAmount ?: 0}" }
            +" scheidsrechters"
        }
        ruleset?.primaryRefereeGroups?.forEach { group ->
            badge(BootstrapColor.Primary, small = true) { +group.groupLabel }
        }
        ruleset?.alternativeRefereeGroups?.forEach { group ->
            badge(BootstrapColor.Secondary, small = true) { +group.groupLabel }
        }
    }
    div(classes = "d-flex flex-wrap small text-muted mb-1") {
        div(classes = "me-2") {
            icon("vp-icon-scoreboard")
            strong { +"${ruleset?.scoreKeeperRequiredAmount ?: 0}" }
            +" tellers"
        }
        ruleset?.primaryScoreKeeperGroups?.forEach { group ->
            badge(BootstrapColor.Primary, small = true) { +group.groupLabel }
        }
        ruleset?.alternativeScoreKeeperGroups?.forEach { group ->
            badge(BootstrapColor.Secondary, small = true) { +group.groupLabel }
        }
    }
}